var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "read-tick") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Message-\\u2709\\uFE0F",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conversation",
    transform: "translate(-322.000000, -292.000000)",
    fill: "#2D90FE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "read-tick",
    transform: "translate(322.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    points: "0 6.45803027 1.37118309 5.15450628 5.27430634 8.0235005 12.5250033 -9.095e-13 13.3319468 0.916191145 5.27430634 11.8254455"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    points: "9 8.5722932 10.3432281 7.02004585 11.9589896 7.79616952 19.3068069 0 19.9605754 0.802205171 12.1670465 11.7924606"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTick);
export default __webpack_public_path__ + "static/media/blue-tick.fea4ae637262ef85eabdb0c0fe7550d0.svg";
export { ForwardRef as ReactComponent };